/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {PageLink, PageTitle} from 'layout/master-layout'
// import {toast} from 'react-toastify'
import {useTranslation} from 'react-i18next'
// import {ILogin} from 'models/Auth'
// import {ITab} from 'helpers/ui-components/KTTab'
import Spinner from 'layout/common/Spinner'
import {useAuth} from 'context/AuthProvider'
import {useNavigate} from 'react-router-dom'
import {
 IActivationConfig,
 IUserAction,
} from 'models/UserManagement'
import {fetchUserDetails} from 'utils/api/auth/userService'
import {IUserDetails} from 'models/Auth'
import {IFormField} from 'models/Common'
import {
 activateUser,
 setActivationStepComplete,
 userActivationConfig,
} from 'utils/api/auth/userManagementService'
import {KTProgressTab} from 'helpers/ui-components/KTProgressTab'
import GeographyMapping from './GeographyMapping'
import NetworkMapping from './NetworkMapping'
import HierarchyMapping from './HierarchyMapping'
import BusinessVertical from './BusinessVertical'
import {toast} from 'react-toastify'

type IProps = {
 userId: string
 setActionDetails: (newState: IUserAction | null) => void
 onReturnToUserManagement?: () => void
 onReturnToTab?: (tabId: string) => void
}

const ActivateUser = (props: IProps) => {
 const {t} = useTranslation()
 const navigate = useNavigate()
 const {userData} = useAuth()
 const [loader, setLoader] = useState(false)
 const [activationConfigList, setActivationConfigList] =
  useState<IActivationConfig[]>([])
 const [userDetails, setUserDetails] =
  useState<IFormField | null>()
 const [activeTab, setActiveTab] = useState(0)
 const [breadcrumbs, setBreadcrumbs] = useState<PageLink[]>(
  [
   {
    title: t('breadCrumbs.userManagement'),
    path: '',
    isActive: false,
    className: 'text-[#4E83E4]',
    onClick: () => {
     props.setActionDetails(null)
     props.onReturnToUserManagement?.()
     navigate('/user-management')
    },
   },
   {
    title: t('breadCrumbs.activate'),
    path: '',
    isActive: false,
    className: 'text-[#4E83E4]',
    onClick: () => {
     props.setActionDetails(null)
     props.onReturnToTab?.('activate')
    },
   },
  ]
 )
 const userDetailsKey = [
  {
   key: 'full_name',
   label: t('userManagement.userDetails.name'),
  },
  {
   key: 'phone_number',
   label: t('userManagement.userDetails.mobile'),
  },
  {
   key: 'gender',
   label: t('userManagement.userDetails.gender'),
  },
  {
   key: 'email',
   label: t('userManagement.userDetails.email'),
  },
  {
   key: 'user_category',
   label: t('userManagement.userDetails.role'),
  },
  {
   key: 'location',
   label: t('userManagement.userDetails.location'),
  },
 ]

 const getUserDetails = async () => {
  setLoader(true)
  const userRes: IUserDetails | null =
   await fetchUserDetails(props.userId)
  if (userRes) {
   console.log('userRes', userRes)
   setUserDetails(userRes)
   setBreadcrumbs((prevState) => [
    ...prevState,
    {
     title: userRes.full_name,
     path: '',
     isActive: true,
    },
   ])
  }
  setLoader(false)
 }

 const getUserActivationConfig = async () => {
  setLoader(true)
  const userRes: IActivationConfig[] | null =
   await userActivationConfig(props.userId)
  if (userRes && userRes?.length > 0) {
   setActivationConfigList(userRes)
  }
  setLoader(false)
 }

 const handleTabClick = async (
  index: number,
  isBackBtnClick: boolean
 ) => {
  const activeTabData = activationConfigList[index]
  if (isBackBtnClick) {
   if (index !== 0) setActiveTab(index - 1)
  } else {
   const res = await setActivationStepComplete({
    user_id: props.userId,
    step_id: activeTabData.id,
   })
   if (res) {
    toast.success(res)
    const tabList = [...activationConfigList]
    tabList[index].status = 'complete'
    setActivationConfigList(tabList)
    if (index === tabList.length - 1) {
     const activeUserResponse = await activateUser(
      Number(props.userId)
     )
     if (activeUserResponse) {
      toast.success(res)
     }
     props.setActionDetails(null)
    } else {
     setActiveTab(index + 1)
    }
   }
  }
 }

 useEffect(() => {
  if (props.userId) {
   void getUserDetails()
   void getUserActivationConfig()
  }
 }, [props.userId])

 const returnUserDetails = (val: {
  key: string
  label: string
 }) => {
  if (userDetails) {
   if (val.key === 'location') {
    const subDistrict = userDetails.sub_district || ''
    const district = userDetails.district || ''
    const state = userDetails.state || ''
    const location = [subDistrict, district, state]
     .filter(Boolean)
     .join(', ')
    return location
   }
   if (val.key === 'gender') {
    return `${userDetails?.profile?.gender}`
   }
   return userDetails?.[val.key]
  }
 }

 return (
  <>
   {loader && <Spinner />}
   <div className='w-full'>
    <PageTitle
     breadcrumbContainerClass={
      'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] border-b'
     }
     breadcrumbs={breadcrumbs}
     description='Welcome'
    >
     Activate User
    </PageTitle>
    <div className='w-full min-h-full'>
     <div className='border-b border-[#E6EBF0] mb-8 mt-4'>
      <div className='grid md:grid-cols-3 gap-5 w-full'>
       {userDetails &&
        userDetailsKey.map((val, key) => (
         <div
          key={key}
          className='flex items-center font-normal text-sm'
         >
          <span className='text-[#5A6066]'>
           {val.label}:
          </span>
          <span className='text-[#000] pl-1'>
           {returnUserDetails(val)}
          </span>
         </div>
        ))}
       <div className='flex items-center'>
        <span className='text-[#5A6066] font-normal text-sm'></span>
       </div>
      </div>
     </div>
     <div className='border-b border-[#E6EBF0] text-[#171B1F] text-xl font-medium mb-8 pb-1'>
      {t('userManagement.activate.completeUserActivation')}
     </div>
     <KTProgressTab
      activeTabId={activeTab}
      containerClass='my-6'
      tabHeaderContainerClass='mb-10'
      tabHeaderClass='px-[20px] text-[#5A6066]'
      headerActiveClass='!text-[#4E83E4]'
      iconActiveClass='!text-white !bg-[#4E83E4] !border-[#4E83E4]'
      tabs={activationConfigList}
      tabContent={
       <div>
        {activationConfigList?.[activeTab]?.key ===
        'geography_mapping' ? (
         <GeographyMapping
          activeTabId={activeTab}
          userId={props.userId}
          setLoader={setLoader}
          handleTabClick={handleTabClick}
          loggedInUserId={userData?.userId}
          userRole={userDetails?.user_category_key}
         />
        ) : activationConfigList?.[activeTab]?.key ===
          'network_mapping' ? (
         <NetworkMapping
          activeTabId={activeTab}
          loggedInUser={userData}
          userId={props.userId}
          userCategoryKey={userDetails?.user_category_key}
          setLoader={setLoader}
          handleTabClick={handleTabClick}
         />
        ) : activationConfigList?.[activeTab]?.key ===
          'hierarchy_mapping' ? (
         <HierarchyMapping
          activeTabId={activeTab}
          loggedInUser={userData}
          userId={props.userId}
          setLoader={setLoader}
          handleTabClick={handleTabClick}
         />
        ) : activationConfigList?.[activeTab]?.key ===
          'line_of_business' ? (
         <BusinessVertical
          activeTabId={activeTab}
          loggedInUser={userData}
          userId={props.userId}
          setLoader={setLoader}
          handleTabClick={handleTabClick}
          userDetails={userDetails}
         />
        ) : (
         <></>
        )}
       </div>
      }
     />
    </div>
   </div>
  </>
 )
}

export {ActivateUser}
